// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fezLI","toggle":"styles_toggle__2ivBk","preview":"styles_preview__Gb32U"};